import React from 'react';
import styled from 'styled-components';
import BatchTextInputTable from "./BatchTextInputTable";
import { hw } from "../homeworkUi";

interface BatchTextInputSectionProps {
    label: string;
    items: { label: string, name: string }[];
    onChangeHandler: (name: string, value: string) => void;
}

const BatchTextInputSection = ({label, items, onChangeHandler }: BatchTextInputSectionProps) => (
    <View>
        <Label>{label}</Label>
        <BatchTextInputTable items={items} onChangeHandler={onChangeHandler} />
    </View>
);

const View = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-height: 280px;
    flex-grow: 1;
    min-width: 0;
`;

const Label = styled.div`
    color: ${hw.text};
    font-size: 13px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

export default BatchTextInputSection;
